import React, { useCallback, useState } from 'react';
import { Button, Card } from '@totalsoft/rocket-ui';
import SyncIcon from '@mui/icons-material/Sync';
import { useTranslation } from 'react-i18next';
import { useToast } from 'hooks/toasts/useToast';
import { useMutation, useSubscription } from 'hooks/apollo';
import { SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS } from '../io/mutations';
import { SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS_COMPLETED, SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS_FAILED } from '../io/subscriptions';

const AssetHierarchyActionsContainer = () => {
  const { t } = useTranslation();
  const addToast = useToast();
  const [disabled, setDisabled] = useState(false);

  const [synchronizeAssetImagesOnDocuments] = useMutation(SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS);

  useSubscription(SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS_COMPLETED, {
    onData: () => {
      addToast(t('AssetHierarchy.Actions.SyncImages.Success'), 'success');
      setDisabled(false);
    }
  });

  useSubscription(SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS_FAILED, {
    onData: data => {
      const message = data.data.data.synchronizeAssetImageOnDocumentsFailed.message;
      addToast(t('AssetHierarchy.Actions.SyncImages.Failure', { message }), 'error');
      setDisabled(false);
    }
  });

  const handleSync = useCallback(() => {
    synchronizeAssetImagesOnDocuments();
    setDisabled(true);
  }, [synchronizeAssetImagesOnDocuments]);

  return (
    <Card icon={SyncIcon} iconColor='primary' title={t('AssetHierarchy.Actions.Title')}>
      <Button disabled={disabled} color='primary' tooltip={t('AssetHierarchy.Actions.SyncImages.Tooltip')} onClick={handleSync}>
        {t('AssetHierarchy.Actions.SyncImages.Label')}
      </Button>
    </Card>
  );
};

export default AssetHierarchyActionsContainer;
